module.exports = __webpack_public_path__ + "static/media/60-r.6fb9b953.png";